module.exports = __webpack_public_path__ + "static/media/6.b8265d6f.jpg";